import React from 'react';
import type { ServiceStatus } from '../../../types/admin';

interface StatusBadgeProps {
  status: ServiceStatus;
  label?: string;
}

const STATUS_CONFIG: Record<ServiceStatus, { color: string; bg: string; text: string }> = {
  healthy: { color: '#28A745', bg: 'rgba(40,167,69,0.12)', text: 'Healthy' },
  degraded: { color: '#FFC107', bg: 'rgba(255,193,7,0.12)', text: 'Degraded' },
  down: { color: '#DC3545', bg: 'rgba(220,53,69,0.12)', text: 'Error' },
  unknown: { color: '#495057', bg: 'rgba(73,80,87,0.12)', text: 'Unknown' },
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label }) => {
  const cfg = STATUS_CONFIG[status] ?? STATUS_CONFIG.unknown;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '3px 10px',
        borderRadius: 4,
        fontSize: '0.7rem',
        fontFamily: "'Roboto Mono', monospace",
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        color: cfg.color,
        background: cfg.bg,
        border: `1px solid ${cfg.color}33`,
        whiteSpace: 'nowrap',
      }}
    >
      <span
        style={{
          width: 7,
          height: 7,
          borderRadius: '50%',
          background: cfg.color,
          flexShrink: 0,
        }}
      />
      {label ?? cfg.text}
    </span>
  );
};
